// [A] Header mobile menu toggle (Grid header)
// Requiere en el HTML:
// - <header class="header ...">...</header>
// - <button class="headerToggle" aria-controls="headerNav" aria-expanded="false">...</button>
// - <nav id="headerNav" class="headerNav">...</nav>
// - <div class="menuOverlay" hidden></div>

(() => {
  const header = document.querySelector(".header");
  const toggle = document.querySelector(".headerToggle");
  const overlay = document.querySelector(".menuOverlay");

  if (!header || !toggle || !overlay) return;

  const navId = toggle.getAttribute("aria-controls");
  const nav = navId ? document.getElementById(navId) : null;

  const setOpen = (open) => {
    header.classList.toggle("isOpen", open);
    if (nav) nav.classList.toggle("isOpen", open);

    toggle.setAttribute("aria-expanded", open ? "true" : "false");

    overlay.hidden = !open;
    overlay.classList.toggle("isVisible", open);

    // Evita scroll del body cuando el menú está abierto (opcional)
    document.body.style.overflow = open ? "hidden" : "";
  };

  const toggleOpen = () => setOpen(!header.classList.contains("isOpen"));

  toggle.addEventListener("click", (e) => {
    e.preventDefault();
    toggleOpen();
  });

  overlay.addEventListener("click", () => setOpen(false));

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setOpen(false);
  });

  // Si pasas a desktop, cierra menú para evitar estados raros
  window.addEventListener("resize", () => {
    if (window.innerWidth > 768) setOpen(false);
  });
})();


// [B] Highlight current menu item (active link)
(() => {
  const nav = document.querySelector("#headerNav");
  if (!nav) return;

  const links = Array.from(nav.querySelectorAll("a[href]"));
  if (!links.length) return;

  // Normaliza la página actual (solo el nombre del fichero)
  const current = (window.location.pathname.split("/").pop() || "index.html").toLowerCase();

  // Limpia estados previos (por si reutilizas el script en SPA-like)
  links.forEach((a) => {
    a.classList.remove("isActive");
    a.removeAttribute("aria-current");
  });

  // Marca activo el que coincide
  const active = links.find((a) => {
    const href = (a.getAttribute("href") || "").split("/").pop().toLowerCase();
    return href === current;
  });

  if (active) {
    active.classList.add("isActive");
    active.setAttribute("aria-current", "page");
  }
})();


// ==========================================
// [C] GA4 loader (solo cuando analytics=true)
// ==========================================

// ✅ Cambia SOLO esta variable en cada sitio web
const GA4_ID = "G-C9JMB3J0T9";

let gaLoaded = false;

function loadGA4() {
  // Safety: si no hay ID válido, no cargamos nada
  if (!GA4_ID || !GA4_ID.startsWith("G-")) return;

  if (gaLoaded) return;
  gaLoaded = true;

  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA4_ID)}`;

  const script2 = document.createElement("script");
  script2.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA4_ID}', { anonymize_ip: true });
  `;

  document.head.appendChild(script1);
  document.head.appendChild(script2);
}


// ==========================================
// [C] BANNER COOKIES COMPORTAMIENTO + GA4
// ==========================================
(() => {
  const KEY = "cookie_prefs_v1";

  const banner = document.getElementById("cookieBanner");
  const modal = document.getElementById("cookieModal");
  const analyticsToggle = document.getElementById("cookieAnalytics");
  const saveBtn = document.getElementById("cookieSavePrefs");
  const openConsent = document.getElementById("open-consent");

  if (!banner || !modal) return;

  const defaultPrefs = { necessary: true, analytics: false };

  const readPrefs = () => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? { ...defaultPrefs, ...JSON.parse(raw) } : null;
    } catch {
      return null;
    }
  };

  const writePrefs = (prefs) => {
    localStorage.setItem(KEY, JSON.stringify({ ...defaultPrefs, ...prefs }));
  };

  const openModal = () => {
    // sync UI con prefs guardadas (o defaults)
    const prefs = readPrefs() || defaultPrefs;
    if (analyticsToggle) analyticsToggle.checked = !!prefs.analytics;

    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
  };

  const closeModal = () => {
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
  };

  const closeBanner = () => {
    banner.hidden = true;
  };

  // 1) Primera carga: si no hay prefs guardadas, mostrar banner
  const prefsOnLoad = readPrefs();
  if (!prefsOnLoad) {
    banner.hidden = false;
  }

  // ✅ Si ya aceptó analítica en el pasado, cargamos GA4 al entrar
  if (prefsOnLoad?.analytics === true) {
    loadGA4();
  }

  // 2) Acciones desde banner y modal
  const handleAction = (action) => {
    if (action === "accept") {
      writePrefs({ analytics: true });
      loadGA4(); // ✅ cargar GA4 al aceptar
      closeBanner();
      closeModal();
      return;
    }

    if (action === "reject") {
      writePrefs({ analytics: false });
      closeBanner();
      closeModal();
      return;
    }

    if (action === "prefs") {
      openModal();
      return;
    }
  };

  // Clicks en botones del banner
  banner.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-cookie-action]");
    if (!btn) return;
    handleAction(btn.getAttribute("data-cookie-action"));
  });

  // Clicks en botones del modal (accept/reject/close)
  modal.addEventListener("click", (e) => {
    const closeEl = e.target.closest("[data-cookie-close]");
    if (closeEl) {
      closeModal();
      return;
    }

    const btn = e.target.closest("[data-cookie-action]");
    if (btn) {
      handleAction(btn.getAttribute("data-cookie-action"));
    }
  });

  // Guardar preferencias
  if (saveBtn) {
    saveBtn.addEventListener("click", () => {
      const prefs = {
        analytics: analyticsToggle ? !!analyticsToggle.checked : false,
      };

      writePrefs(prefs);

      // ✅ Si activó analítica desde preferencias, cargamos GA4
      if (prefs.analytics === true) {
        loadGA4();
      }

      closeBanner();
      closeModal();
    });
  }

  // Link footer: abre preferencias
  if (openConsent) {
    openConsent.addEventListener("click", (e) => {
      e.preventDefault();
      openModal();
    });
  }

  // ESC cierra modal
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !modal.hidden) closeModal();
  });
})();
